import { axios } from '../../../axios';

const getProperties = (query) => {
  return axios.get(`/properties`, {
    headers: {
      Authorization: `Bearer ${ localStorage.getItem("token") }`
    },
    params: query
  })
}

export { getProperties }